<ion-header no-border>
    <ion-toolbar class="ion-text-center">
        <ion-title>Let's draw together!</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="dismissModal()">
                <ion-icon name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <canvas #drawCanvas></canvas>
    <ion-fab vertical="top" horizontal="start" >
        <ion-fab-button size="small" color="tertiary">
            {{occupancy}}
        </ion-fab-button>
    </ion-fab>
    <ion-fab vertical="bottom" horizontal="end" >
        <ion-fab-button [style.--background]="color">
                <ion-icon name="brush"></ion-icon>
        </ion-fab-button>
        <ion-fab-list side="top">
            <ion-fab-button [style.--background]="'#FFF'" (click)="color = '#FFF'"></ion-fab-button>
            <ion-fab-button [style.--background]="'#000'" (click)="color = '#000'"></ion-fab-button>
            <ion-fab-button [style.--background]="'#9313CE'" (click)="color = '#9313CE'"></ion-fab-button>
            <ion-fab-button [style.--background]="'#EC5C0D'" (click)="color = '#EC5C0D'"></ion-fab-button>
            <ion-fab-button [style.--background]="'#D42E23'" (click)="color = '#D42E23'"></ion-fab-button>
        </ion-fab-list>
    </ion-fab>
</ion-content>
